import * as XLSX from 'xlsx';
import Parameters from '@/assets/js/parameters'
import shareds from '@/assets/js/shared';
class Diss {
    constructor(apiService = null) {

        this.parameters = new Parameters()
        this.shared = new shareds()

        this.obj_name = 'diss';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性

        this.deathTypeList = [
            { id:0 , name:'住院中死亡' },
            { id:1 , name:'安樂死' },
            { id:2 , name:'到院前死亡' },
        ]

        this.storageConditionsList = [
            { id:1 , name:'當天新鮮' },
            { id:2 , name:'2天內冷藏' },
            { id:3 , name:'2天以上冷藏' },
            { id:4 , name:'冷凍過' },
        ]
        this.degreeDecompositionList = [
            { id:1 , name:'輕度' },
            { id:2 , name:'中度' },
            { id:3 , name:'重度' },
        ]

        
        this.genderList = this.parameters.genderList

        this.pregnancyStatusList = this.parameters.pregnancyStatusList

        this.nutritionalConditionList = [
            { id:1 , name:'Emaciation' },
            { id:2 , name:'Mild thin' },
            { id:3 , name:'Ideal' },
            { id:4 , name:'Moderate fat' },
            { id:5 , name:'Obese' },
        ]
        this.hydrationList = [
            { id:1 , name:'normal' },
            { id:2 , name:'mild dehydration' },
            { id:3 , name:'severe dehydration' },
            { id:4 , name:'N/A' },
        ]

        this.poison = [
            {value: 1 , name: '肝'},
            {value: 2 , name: '胃內容物'},
            {value: 99 , name: '其他'},
        ],
        this.wound_microorganisms = [
            {value: 1 , name: '毛髮'},
            {value: 2 , name: '口水拭子'},
            {value: 3 , name: '組織'},
            {value: 99 , name: '其他'},
        ],
        this.frozen_tissue = [
            {value: 1 , name: '心'},
            {value: 2 , name: '肝'},
            {value: 3 , name: '脾'},
            {value: 4 , name: '肺'},
            {value: 5 , name: '腎'},
            {value: 6 , name: '大腸、小腸'},
            {value: 7 , name: '胃'},
            {value: 8 , name: '膀胱'},
            {value: 9 , name: '腦'},
            {value: 10 , name: '皮膚'},
            {value: 11 , name: '肌肉'},
            {value: 99 , name: '其他'},
        ],
        this.specimen = [
            {value: 1 , name: '剝制標本'},
            {value: 2 , name: '骨骼標本'},
            {value: 99 , name: '其他'},
        ]
    }
    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }
    // 表單檢查
    checkCreateFormModel(formData) {
        const validations = [
            { condition: formData.doctor_id === -1, message: '請選擇病理獸醫師' },
            { condition: formData.death_type === -1, message: '請選擇動物死亡方式' },
            { condition: formData.storage_conditions === -1, message: '請選擇保存條件' },
            // { condition: formData.degree_of_decomposition === -1, message: '請選擇腐敗程度' },
            // { condition: formData.prenecropsy_weight === 0 , message: '剖檢前體重不得為0' },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    paddedInjuryRecode(injuryRecode) {
        const minRecords = 3;
        const padded = injuryRecode ? [...injuryRecode] : [];
        while ( padded.length < minRecords) {
            padded.push({
                body_parts: '',
                trauma_type: '',
                trauma_note: ''
            });
        }
        return padded;
    }
    paddedWaxBlockTissueRecord(wax_block_tissue_record){
        const minRecords = 8;
        const padded = wax_block_tissue_record ? [...wax_block_tissue_record] : [];
        while ( padded.length < minRecords) {
            padded.push('');
        }
        return padded;
    }
    //取得資料後整理成畫面要用的格式
    organizeDataFormat(resDate){
        let dissection_json = resDate.dissection_json

        const wax_block_tissue_record = this.paddedWaxBlockTissueRecord(dissection_json.cross_finding.histological_data.wax_block_tissue_record)
        dissection_json.cross_finding.histological_data.wax_block_tissue_record = wax_block_tissue_record

        const cross_finding = {
            nutritional_condition: dissection_json.cross_finding.nutritional_condition,
            nutritional_condition_note: dissection_json.cross_finding.nutritional_condition_note,
            hydration: dissection_json.cross_finding.hydration,
            no_injury: dissection_json.cross_finding.no_injury,
            wound: dissection_json.cross_finding.wound,
            internal_injury: dissection_json.cross_finding.internal_injury,
            woundData:{
                woundCount: dissection_json.cross_finding.woundData.woundCount,
                injuryRecode: this.paddedInjuryRecode(dissection_json.cross_finding.woundData.injuryRecode),
                internal_phtoto_url_json: JSON.stringify(dissection_json.cross_finding.internal_phtoto_url_json),
            },
            internalInjuryData: dissection_json.cross_finding.internalInjuryData,
            histologicalType: dissection_json.cross_finding.histologicalType,
            histological_data: dissection_json.cross_finding.histological_data,
            other_gross_lesions: dissection_json.cross_finding.other_gross_lesions,
            entomological_evidence: dissection_json.cross_finding.entomological_evidence,
            gross_diagnosis: dissection_json.cross_finding.gross_diagnosis,
            comment: dissection_json.cross_finding.comment,
        }
        //處理資料型態必須為陣列
        const photo_url_json = Array.isArray(resDate.photo_url_json) ? resDate.photo_url_json : []

        return {
            medical_record_id: resDate.medical_record_id,
            dissection_date: this.apiService.shared.formatIosDate(resDate.dissection_date),
            doctor_id: resDate.doctor_id,
            death_type: resDate.death_type,
            storage_conditions: resDate.storage_conditions,
            degree_of_decomposition: resDate.degree_of_decomposition,
            prenecropsy_weight: resDate.prenecropsy_weight,
            dissection_json: {
                base_info: dissection_json.base_info,
                cross_finding: cross_finding,
                sample_preservation: resDate.dissection_json.sample_preservation
            },
            photo_url_json: JSON.stringify(photo_url_json)
        }
    }
    //排除掉空的欄位
    excludeInjuryRecodeBlankFields(injuryRecode){
        let recode = []
        for (let index = 0; index < injuryRecode.length; index++) {
            const injury = injuryRecode[index];
            if (
                injury.body_parts.trim() !== '' ||
                injury.trauma_type.trim() !== '' ||
                injury.trauma_note.trim() !== ''
            ){
                recode.push(injury)
            }
        }
        return recode
    }
    excludeWaxBlockTissueRecordBlankFields(wax_block_tissue_record){
        let recode = []
        for (let index = 0; index < wax_block_tissue_record.length; index++) {
            if (
                wax_block_tissue_record[index].trim() !== '' 
            ){
                recode.push(wax_block_tissue_record[index].trim())
            }
        }
        return recode
    }
    //整理post api資料格式
    formDataModelHandle(formData){

        console.log(`formData.prenecropsy_weight=` , formData.prenecropsy_weight)

        let objFrom = new FormData()
        
        objFrom.append('dissection_date',formData.dissection_date)
        objFrom.append('doctor_id',formData.doctor_id)
        objFrom.append('death_type',formData.death_type)
        objFrom.append('storage_conditions',formData.storage_conditions)
        objFrom.append('degree_of_decomposition',formData.degree_of_decomposition)
        objFrom.append('prenecropsy_weight',formData.prenecropsy_weight != '' ? formData.prenecropsy_weight : 0)

        //處理剖檢紀錄
        let base_info = {
            gender_id: formData.dissection_json.base_info.gender_id,
            pregnancy_status: formData.dissection_json.base_info.pregnancy_status
        }
        let cross_finding = {
            nutritional_condition: formData.dissection_json.cross_finding.nutritional_condition,
            nutritional_condition_note: formData.dissection_json.cross_finding.nutritional_condition_note,
            hydration: formData.dissection_json.cross_finding.hydration,
            no_injury: formData.dissection_json.cross_finding.no_injury,
            wound: formData.dissection_json.cross_finding.wound,
            internal_injury: formData.dissection_json.cross_finding.internal_injury,
            woundData:{
                woundCount: formData.dissection_json.cross_finding.woundData.woundCount,
                injuryRecode: this.excludeInjuryRecodeBlankFields(formData.dissection_json.cross_finding.woundData.injuryRecode),
            },
            internalInjuryData:{
                note: formData.dissection_json.cross_finding.internalInjuryData.note
            },
            histologicalType: formData.dissection_json.cross_finding.histologicalType,
            histological_data:{
                note: formData.dissection_json.cross_finding.histological_data.note,
                morphological_diagnosis: formData.dissection_json.cross_finding.histological_data.morphological_diagnosis,
                wax_block_tissue_record: this.excludeWaxBlockTissueRecordBlankFields(formData.dissection_json.cross_finding.histological_data.wax_block_tissue_record)
            },
            other_gross_lesions: formData.dissection_json.cross_finding.other_gross_lesions,
            entomological_evidence: formData.dissection_json.cross_finding.entomological_evidence,
            gross_diagnosis: formData.dissection_json.cross_finding.gross_diagnosis,
            comment: formData.dissection_json.cross_finding.comment,
            internal_phtoto_url_json: JSON.parse(formData.dissection_json.cross_finding.woundData.internal_phtoto_url_json)
        }
        console.log( `formData.dissection_json.sample_preservation.poison = ` , formData.dissection_json.sample_preservation.poison)
        let sample_preservation = {
            isNoCollection: formData.dissection_json.sample_preservation.isNoCollection,
            formalin: formData.dissection_json.sample_preservation.formalin,
            poison:{
                list: formData.dissection_json.sample_preservation.poison.list,
                note: formData.dissection_json.sample_preservation.poison.note
            },
            wound_microorganisms:{
                list: formData.dissection_json.sample_preservation.wound_microorganisms.list,
                note: formData.dissection_json.sample_preservation.wound_microorganisms.note
            },
            parasites: formData.dissection_json.sample_preservation.parasites,
            frozen_tissue:{
                list: formData.dissection_json.sample_preservation.frozen_tissue.list,
                note: formData.dissection_json.sample_preservation.frozen_tissue.note
            },
            specimen:{
                list: formData.dissection_json.sample_preservation.specimen.list,
                note: formData.dissection_json.sample_preservation.specimen.note
            },
            note: formData.dissection_json.sample_preservation.note
        }

        const dissection_json = {
            base_info: base_info,
            cross_finding: cross_finding,
            sample_preservation: sample_preservation
        }

        console.log('save: ' , dissection_json)

        objFrom.append('dissection_json',JSON.stringify(dissection_json))
        objFrom.append('photo_url_json',formData.photo_url_json)

        return objFrom
    }
    getInjuryRecodeFields(form){
        let maxWoundData = 0
        for (let index = 0; index < form.length; index++) {
            const dissection = JSON.parse(form[index].dissection_json);
            console.log(`dissection:`,dissection)
            const woundData = dissection.cross_finding.woundData.injuryRecode
            if ( woundData.length > maxWoundData){
                maxWoundData = woundData.length
            }
        }
        return maxWoundData
    }
    getWaxBlockTissueRecordFields(form){
        let recordCount = 0
        for (let index = 0; index < form.length; index++) {
            const dissection = JSON.parse(form[index].dissection_json);
            console.log(`dissection:`,dissection)
            const wax_block_tissue_record = dissection.cross_finding.histological_data.wax_block_tissue_record
            if ( wax_block_tissue_record.length > recordCount){
                recordCount = wax_block_tissue_record.length
            }
        }
        return recordCount
    }
    getDataWithHeaders(form) {
        let headers = [];
        //設定標題
        headers.push('病歷號碼')
        headers.push('剖檢日期')
        headers.push('病理獸醫師')
        headers.push('動物死亡方式')
        headers.push('保存條件')
        headers.push('腐敗程度')
        headers.push('剖檢前體重')
        headers.push('動物性別')
        headers.push('懷孕狀況')
        headers.push('營養狀況')
        headers.push('營養狀況說明')
        headers.push('水合狀況')
        headers.push('創傷')
        headers.push('外傷')
        headers.push('傷口總數量')
        const district1_index = headers.length-1
        //處理傷口紀錄的欄位
        let max = 0
        max = this.getInjuryRecodeFields(form)
        for (let index = 1; index <= max; index++) {
            headers.push(`傷口紀錄${index}`)
        }
        const injuryRecode_index = headers.length-1
        headers.push('內傷')
        headers.push('內傷描述')
        headers.push('其他肉眼病變紀錄')
        headers.push('昆蟲學證據')
        headers.push('肉眼診斷')
        headers.push('組織學紀錄')
        headers.push('組織學描述')
        headers.push('型態學診斷')
        const district2_index = headers.length-1
        //處理臘塊組織紀錄
        max = this.getWaxBlockTissueRecordFields(form)
        for (let index = 1; index <= max; index++) {
            headers.push(`蠟塊組織紀錄${index}`)
        }
        const waxBlockTissueRecord_index = headers.length-1
        headers.push('病例討論')
        headers.push('檢體保存紀錄')
        headers.push('福馬林檢體')
        headers.push('毒物檢體')
        headers.push('傷口微物跡證採集')
        headers.push('寄生蟲')
        headers.push('冷凍組織保存')
        headers.push('標本留存')
        headers.push('備註')
        // const full_index = headers.length-1
        //處理資料
        let data = [];
        for (let index = 0; index < form.length; index++) {
            let item = form[index];
            const dissection = JSON.parse(item.dissection_json)
            let rowData = []
            rowData.push(item.medical_sn)
            rowData.push( this.shared.formatIosDate(item.dissection_date))
            rowData.push(item.doctor_name)
            const death_type = this.deathTypeList.find(op=>op.id == parseInt(item.death_type) )
            rowData.push( death_type ? death_type.name : '' )
            const storage_conditions = this.storageConditionsList.find(op=>op.id == parseInt(item.storage_conditions) )
            rowData.push( storage_conditions ? storage_conditions.name : '' )
            
            const degree_of_decomposition = this.degreeDecompositionList.find(op=>op.id == parseInt(item.degree_of_decomposition) )
            rowData.push( degree_of_decomposition ? degree_of_decomposition.name : '' )
            rowData.push(item.prenecropsy_weight)
            const gender = this.genderList.find(op=>op.id == parseInt(dissection.base_info.gender_id) )
            rowData.push( gender ? gender.name : '' )
            const pregnancy_status = this.pregnancyStatusList.find(op=>op.id == parseInt(dissection.base_info.pregnancy_status) )
            rowData.push( pregnancy_status ? pregnancy_status.name : '' )
            const nutritional_condition = this.nutritionalConditionList.find(op=>op.id == parseInt(dissection.cross_finding.nutritional_condition) )
            rowData.push( nutritional_condition ? nutritional_condition.name : '' )
            rowData.push(dissection.cross_finding.nutritional_condition_note)
            const hydration = this.hydrationList.find(op=>op.id == parseInt(dissection.cross_finding.hydration) )
            rowData.push( hydration ? hydration.name : '' )
            rowData.push( dissection.cross_finding.no_injury ? '有' : '無' )
            rowData.push( dissection.cross_finding.wound ? '有' : '無' )
            rowData.push( dissection.cross_finding.woundData.woundCount )
            //要處理傷口紀錄
            
            for (let index = district1_index; index < injuryRecode_index; index++) {
                const injuryRecodeIndex = index -  district1_index
                const recode = dissection.cross_finding.woundData.injuryRecode[injuryRecodeIndex]
                const string = recode ? `部位:${recode.body_parts} , 創傷種類:${recode.trauma_type} , 描述:${recode.trauma_note}` : ''
                rowData.push( string )
            }
            rowData.push( dissection.cross_finding.internal_injury ? '有' : '無' )
            rowData.push( dissection.cross_finding.internalInjuryData.note )
            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.other_gross_lesions) )
            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.entomological_evidence) )
            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.gross_diagnosis) )
            rowData.push( dissection.cross_finding.histologicalType ? '有' : '無' )
            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.histological_data.note) )
            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.histological_data.morphological_diagnosis) )
            //開始處理蠟塊紀錄
            for (let index = district2_index; index < waxBlockTissueRecord_index; index++) {
                const waxBlockRecodeIndex = index -  district2_index
                const recode = dissection.cross_finding.histological_data.wax_block_tissue_record[waxBlockRecodeIndex]
                const string = recode ? recode : ''
                rowData.push( string )
            }

            rowData.push( this.shared.replaceAndStripHTML(dissection.cross_finding.comment) )
            //dissection.sample_preservation
            rowData.push( dissection.sample_preservation.isNoCollection ? '' : '皆無採集' )
            rowData.push( dissection.sample_preservation.formalin ? '有' : '無' )
            //處理字串合併
            let poisonAry = []
            for (let index = 0; index < dissection.sample_preservation.poison.list.length; index++) {
                const itemValue = dissection.sample_preservation.poison.list[index];
                const note = dissection.sample_preservation.poison.note ? dissection.sample_preservation.poison.note : ''
                let string = (itemValue !== 99 ) ? this.poison.find(op=>op.value == parseInt(itemValue)) : { name:`其他:${note}` }
                poisonAry.push( string ? string.name : '' )
            }
            rowData.push( poisonAry.join(',') )
            //處理字串合併
            let woundMicroorganismsAry = []
            for (let index = 0; index < dissection.sample_preservation.wound_microorganisms.list.length; index++) {
                const itemValue = dissection.sample_preservation.wound_microorganisms.list[index];
                const note = dissection.sample_preservation.wound_microorganisms.note ? dissection.sample_preservation.wound_microorganisms.note : ''
                let string = (itemValue !== 99 ) ? this.wound_microorganisms.find(op=>op.value == parseInt(itemValue)) : { name:`其他:${note}` }
                woundMicroorganismsAry.push( string ? string.name : '' )
            }
            rowData.push( woundMicroorganismsAry.join(',') )
            rowData.push( dissection.sample_preservation.parasites )
            //處理字串合併
            let frozenTissueAry = []
            for (let index = 0; index < dissection.sample_preservation.frozen_tissue.list.length; index++) {
                const itemValue = dissection.sample_preservation.frozen_tissue.list[index];
                const note = dissection.sample_preservation.frozen_tissue.note ? dissection.sample_preservation.frozen_tissue.note : ''
                let string = (itemValue !== 99 ) ? this.frozen_tissue.find(op=>op.value == parseInt(itemValue)) : { name:`其他:${note}` }
                frozenTissueAry.push( string ? string.name : '' )
            }
            rowData.push( frozenTissueAry.join(',') )
            //處理字串合併
            let specimenAry = []
            for (let index = 0; index < dissection.sample_preservation.specimen.list.length; index++) {
                const itemValue = dissection.sample_preservation.specimen.list[index];
                const note = dissection.sample_preservation.specimen.note ? dissection.sample_preservation.specimen.note : ''
                let string = (itemValue !== 99 ) ? this.specimen.find(op=>op.value == parseInt(itemValue)) : { name:`其他:${note}` }
                specimenAry.push( string ? string.name : '' )
            }
            rowData.push( specimenAry.join(',') )
            rowData.push( this.shared.replaceAndStripHTML(dissection.sample_preservation.note) )


            data.push(rowData)

            
        }

        return [headers, ...data];
    }

    async exportExcel(data) {
        console.log(`exportExcel=`, data);
        const dataWithHeaders = this.getDataWithHeaders(data);
        console.log(`dataWithHeaders:`, dataWithHeaders);
        // 生成工作表和工作簿
        const worksheet = XLSX.utils.aoa_to_sheet(dataWithHeaders); // aoa 表示數組數組結構
        // 設定自動寬度
        const colWidths = dataWithHeaders[0].map((_, colIndex) =>
            Math.max(
                ...dataWithHeaders.map(row => (row[colIndex] ? row[colIndex].toString().length : 0))
            )
        );
        worksheet['!cols'] = colWidths.map(width => ({ wch: width + 6 })); // wch: 寬度，+2 是增加緩衝
        // 設定凍結標題列和病歷編號欄
        worksheet['!freeze'] = {
            xSplit: 1, // 病歷編號欄 (第 1 欄，索引從 0 開始)
            ySplit: 1, // 標題列 (第 1 行，索引從 0 開始)
            topLeftCell: "B2", // 冰凍後的起始顯示單元格
        };
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        // 下載檔案
        XLSX.writeFile(workbook, "解剖報告.xlsx");
    }
    

    // API 方法
    //解剖 | 101新增解剖
    async addDissectionReport(parameter, progressEvent = null) {
        return this.callApi('post', 'addDissectionReport', parameter, progressEvent);
    }
    // 解剖 | 102取得解剖詳細資料
    async getDissectionReportByMedicalRecordId(parameter) {
        return this.callApi('get', 'getDissectionReportByMedicalRecordId', parameter);
    }
    //解剖 | 103更新解剖
    async updDissectionReport(parameter, progressEvent = null) {
        return this.callApi('post', 'updDissectionReport', parameter, progressEvent);
    }
    // 解剖 | 104搜尋解剖紀錄
    async getDissectionReportByStartEndDateWithPage(parameter) {
        return this.callApi('get', 'getDissectionReportByStartEndDateWithPage', parameter);
    }
    // 解剖 | 105取得解剖列表
    async getExportDissectionReportByJson(parameter) {
        return this.callApi('get', 'getExportDissectionReportByJson', parameter);
    }
    // 解剖 | 106取得待解剖列表
    async getMedicalRecord93ByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMedicalRecord93ByKeywordWithPage', parameter);
    }

    /**
     * 取得備份用的 Key
     * @param {string|number} medical_record_id 
     * @returns {string} Key
     */
    getBackupKey(medical_record_id) {
        return `diss_report_backup_${medical_record_id}`;
    }

    /**
     * 儲存暫存資料到 localStorage
     * @param {string|number} medical_record_id 
     * @param {object} data 
     */
    saveTempData(medical_record_id, data) {
        if (!medical_record_id || !data) return;
        
        try {
            const key = this.getBackupKey(medical_record_id);
            // 加上時間戳記，方便 debug 或為了未來擴充過期機制
            const backupData = {
                timestamp: new Date().getTime(),
                data: data
            };
            localStorage.setItem(key, JSON.stringify(backupData));
            console.log(`[Diss] Data backed up for medical_record_id: ${medical_record_id}`);
        } catch (e) {
            console.error('[Diss] Failed to save temp data:', e);
        }
    }

    /**
     * 從 localStorage 取得暫存資料
     * @param {string|number} medical_record_id 
     * @returns {object|null}
     */
    getTempData(medical_record_id) {
        if (!medical_record_id) return null;

        try {
            const key = this.getBackupKey(medical_record_id);
            const jsonStr = localStorage.getItem(key);
            if (!jsonStr) return null;

            const backupData = JSON.parse(jsonStr);
            console.log(`[Diss] Found backup data for medical_record_id: ${medical_record_id}`, backupData);
            return backupData.data;
        } catch (e) {
            console.error('[Diss] Failed to get temp data:', e);
            return null;
        }
    }

    /**
     * 清除 localStorage 中的暫存資料
     * @param {string|number} medical_record_id 
     */
    removeTempData(medical_record_id) {
        if (!medical_record_id) return;

        try {
            const key = this.getBackupKey(medical_record_id);
            localStorage.removeItem(key);
            console.log(`[Diss] Backup data removed for medical_record_id: ${medical_record_id}`);
        } catch (e) {
            console.error('[Diss] Failed to remove temp data:', e);
        }
    }
}

export default Diss;
